import { Box } from "@mui/material";
import { grey } from "@mui/material/colors";

export interface ContentProps {
  "data-testid"?: string;
  /** Set when a toolbar row above Content already supplies the tab-to-form gap. */
  disableTopPadding?: boolean;
}

const Content: React.FC<React.PropsWithChildren<ContentProps>> = (props) => (
  <Box
  textAlign="left"
  sx={{
    backgroundColor: grey[100],
    minHeight: "100vh",
    position: "relative",
    pl: { xs: 2, sm: 6 },
    pr: { xs: 2, sm: 6 },
    pt: props.disableTopPadding ? 0 : 4,
    pb: { xs: 2, sm: 6 },
  }}
    data-testid={props["data-testid"]}
  >
    {props.children}
  </Box>
);

export default Content;
